import React, { useEffect, useState } from "react";
import { Table } from "rsuite";

type EditCellProps = {
  rowData?: any;
  dataKey?: string;
  defaultValue?: any;
  onChange: Function;
};

const EditCell = ({
  rowData,
  dataKey,
  defaultValue = "",
  onChange,
  ...props
}: EditCellProps) => {
  const { Cell } = Table;

  const resolveValue = () => {
    if (dataKey && rowData?.[dataKey] != null) {
      return rowData[dataKey];
    }

    if (typeof defaultValue === "function") {
      return defaultValue(rowData);
    }

    return defaultValue;
  };

  const [value, setValue] = useState(resolveValue());

  useEffect(() => {
    setValue(resolveValue());
  }, [rowData, dataKey, defaultValue]);

  return (
    <Cell {...props} className="table-content-editing">
      <input
        className="rs-input"
        value={value}
        onChange={(event) => {
          const newValue = event.target.value;
          setValue(newValue);
          onChange?.(rowData?.id, dataKey, newValue);
        }}
      />
    </Cell>
  );
};

export default EditCell;
